import { gql } from '@apollo/client';

const REMOVE_UPCOMING_ACADEMIC_SESSION_SETTING = gql`
  mutation removeUpcomingAcademicSessionSetting($where: OrganizationSettingWhereInput!) {
    removeOrganizationSetting(where: $where)
  }
`;

export default REMOVE_UPCOMING_ACADEMIC_SESSION_SETTING;
